import { RootState } from '../../../RootState';
import { State as LayoutUIState } from './reducer';

export const selectLayoutUI = (state: RootState): LayoutUIState => state.layoutUI;
